import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const TabNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(location?.pathname);

  useEffect(() => {
    setActiveTab(location?.pathname);
  }, [location?.pathname]);

  const navigationItems = [
    {
      label: 'Главная',
      path: '/main-dashboard',
      icon: 'Home',
      tooltip: 'Главная страница с рекомендациями'
    },
    {
      label: 'Поиск',
      path: '/search-and-discovery',
      icon: 'Search',
      tooltip: 'Поиск контента и каналов'
    },
    {
      label: 'Эфир',
      path: '/live-broadcasting-studio',
      icon: 'Radio',
      tooltip: 'Студия прямого эфира'
    },
    {
      label: 'Профиль',
      path: '/user-profile-settings',
      icon: 'User',
      tooltip: 'Личный профиль и настройки'
    }
  ];

  const handleNavigation = (path) => {
    navigate(path);
  };

  const isActive = (path) => {
    return activeTab === path || activeTab?.startsWith(path);
  };

  return (
    <nav 
      className="tab-navigation"
      role="navigation"
      aria-label="Основная навигация">
      
      <div className="nav-container">
        <div className="tab-navigation-logo flex items-center h-16">
          <div className="logo-container flex items-center gap-3">
            <div className="logo-icon w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center transition-all duration-300 hover:bg-primary/20">
              <Icon name="Radio" size={24} color="var(--color-primary)" />
            </div>
            <span className="logo-text text-xl font-heading font-semibold text-foreground">
              Radio Co Im
            </span>
          </div>
        </div>
        
        <ul className="tab-navigation-list flex items-center gap-2 ml-12">
          {navigationItems?.map((item) => (
            <li key={item?.path} className="tab-navigation-item">
              <button
                onClick={() => handleNavigation(item?.path)}
                className={`tab-navigation-link flex items-center gap-2 px-4 py-2 rounded-lg transition-all duration-200 ease-smooth ${
                  isActive(item?.path)
                    ? 'bg-primary text-primary-foreground'
                    : 'text-muted-foreground hover:text-foreground hover:bg-muted'
                }`}
                title={item?.tooltip}
                aria-label={item?.tooltip}
                aria-current={isActive(item?.path) ? 'page' : undefined}
              >
                <Icon 
                  name={item?.icon} 
                  size={20} 
                  color={isActive(item?.path) ? 'var(--color-primary-foreground)' : 'currentColor'}
                />
                <span className="font-heading font-medium">{item?.label}</span>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default TabNavigation;